/**
 * @generated SignedSource<<dfccc71dfa6cf55a1d657c8cc6d765e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentTestAccountBanner_charge$data = {
  readonly id: string;
  readonly isFromTestAccount: boolean | null | undefined;
  readonly " $fragmentType": "PaymentTestAccountBanner_charge";
};
export type PaymentTestAccountBanner_charge$key = {
  readonly " $data"?: PaymentTestAccountBanner_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentTestAccountBanner_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentTestAccountBanner_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromTestAccount",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "47bba1218e9235458dc0a87acf752608";

export default node;
